module.exports = __webpack_public_path__ + "media/images/logo-wcpo-cae2622cc71fa18086ad6d70d7afa7f2.png";